// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `boxx-custom-modal {
  --boxx-modal-header-background: var(--ion-color-medium, grey);
}

ion-avatar {
  width: 10px;
  height: 10px;
  border: none;
}

.local {
  background: #A39127;
}

.mobile {
  background: #7D7CDF;
}

ion-item-divider {
  --padding-start: 0px;
  --inner-padding-end: 0px;
}

#previousLoadContainer {
  min-height: 4rem;
  position: relative;
  margin-top: 22%;
}
#previousLoadContainer ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  margin: -4% 0 0 -25%;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/categories-picker/categories-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,6DAAA;AACF;;AAEA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACA;;AAEA;EACA,mBAAA;AACA;;AAEA;EACA,mBAAA;AACA;;AAGA;EACE,oBAAA;EACA,wBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AAAF;AAEE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;AAAJ","sourcesContent":["boxx-custom-modal{\n  --boxx-modal-header-background: var(--ion-color-medium, grey);\n}\n\nion-avatar{\nwidth: 10px;\nheight: 10px;\nborder: none;\n}\n\n.local{\nbackground: #A39127;\n}\n\n.mobile{\nbackground: #7D7CDF;\n}\n\n\nion-item-divider {\n  --padding-start: 0px;\n  --inner-padding-end: 0px;\n}\n\n#previousLoadContainer{\n  min-height: 4rem;\n  position: relative;\n  margin-top: 22%;\n\n  ion-spinner{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 50%;\n    margin: -4% 0 0 -25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
